import React from "react";
import { CircularProgress, Box, Backdrop } from "@mui/material";

export default function LoaderOverlay() {
  document.body.style.overflow = "auto";
  return (
    <>
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: 9999,
        }}
        open={true}
      >
        <Box display="flex" flexDirection="column" alignItems="center">
          <CircularProgress color="secondary" />
          <Box mt={2}>Loading...</Box>
        </Box>
      </Backdrop>
    </>
  );
}
